import { AsyncState, Updater, unloadedAsyncState } from 'widgets-for-react'
import { UserSubscriptions } from '../../../subscription/subscriptionState'
import { loadSubmitContactForm } from './contactApi'

export const contactFormInputs = [
  'email',
  'name',
  'surname',
  'subject',
  'message',
] as const

export type ContactFormInput = typeof contactFormInputs[number]

export type ContactState = {
  formInput: Partial<{ [field in ContactFormInput]: string }>
  showFormInputValidation: { [field in ContactFormInput]: boolean }
  submitState: AsyncState<{}>
}

export const initialContactState = (
  userSubscriptionsState: AsyncState<UserSubscriptions>
): ContactState => {
  const formInput =
    userSubscriptionsState.kind == 'loaded'
      ? {
          email: userSubscriptionsState.value.User.Email,
          name: userSubscriptionsState.value.User.Name,
          surname: userSubscriptionsState.value.User.Surname,
        }
      : {}
  return {
    formInput: formInput,
    showFormInputValidation: {
      email: false,
      name: false,
      surname: false,
      subject: false,
      message: false,
    },
    submitState: unloadedAsyncState(),
  }
}

export const contactStateUpdaters = {
  updateSubmitState:
    (updater: Updater<AsyncState<{}>>) =>
    (state: ContactState): ContactState => ({
      ...state,
      submitState: updater(state.submitState),
    }),
  updateFormInput:
    (field: ContactFormInput, newValue: string) =>
    (state: ContactState): ContactState => ({
      ...state,
      formInput: {
        ...state.formInput,
        [field]: newValue,
      },
    }),
  showFormInputValition:
    (field: ContactFormInput) =>
    (state: ContactState): ContactState => ({
      ...state,
      showFormInputValidation: {
        ...state.showFormInputValidation,
        [field]: true,
      },
    }),
  submit: (state: ContactState): ContactState => ({
    ...state,
    submitState: loadSubmitContactForm(
      state.formInput.email || '',
      state.formInput.name || '',
      state.formInput.surname || '',
      state.formInput.subject || '',
      state.formInput.message || ''
    ),
  }),
}
